/**
 * Realtime konteksti va hooklari.
 *
 * Provayder komponentidan ALOHIDA fayl: `react-refresh` qoidasi bir faylda
 * komponent va boshqa eksportlar birga turishini ogohlantiradi, va u
 * haqli — aralashganda hot reload komponent holatini yo'qotadi.
 */

import type { WsEvent } from '@voice/api-client';
import { createContext, useContext, useEffect, useRef } from 'react';

export type RealtimeStatus = 'connecting' | 'open' | 'error';

export type RealtimeListener = (event: WsEvent) => void;

export interface RealtimeValue {
  status: RealtimeStatus;
  subscribe: (listener: RealtimeListener) => () => void;
}

export const RealtimeContext = createContext<RealtimeValue>({
  status: 'connecting',
  subscribe: () => () => undefined,
});

/** Eventlarni tinglaydi. `handler` har renderda yangi bo'lishi mumkin. */
export function useRealtimeEvents(handler: RealtimeListener): void {
  const { subscribe } = useContext(RealtimeContext);
  const ref = useRef(handler);

  useEffect(() => {
    ref.current = handler;
  });

  useEffect(() => subscribe((event) => ref.current(event)), [subscribe]);
}

export function useRealtimeStatus(): RealtimeStatus {
  return useContext(RealtimeContext).status;
}
